/**
 * Vocabulaire des actions planifiables — partagé par la fiche entreprise
 * (« Planifier une action »), l'onglet Actions, la page Tâches et le
 * calendrier, pour qu'un type créé à un endroit s'affiche partout avec le
 * même libellé. Les identifiants sont ceux stockés côté serveur (models.TaskInput).
 */
export const ACTION_TYPES = [
  { id: "MEETING", label: "Rendez-vous" },
  { id: "DEMO", label: "Démo" },
  { id: "VIDEO", label: "Vidéo de démo" },
  { id: "EMAIL", label: "Email" },
  { id: "CALL", label: "Appel" },
  { id: "FOLLOW_UP", label: "Suivi" },
  { id: "OTHER", label: "Autre" },
];

const LABELS = Object.fromEntries(ACTION_TYPES.map((a) => [a.id, a.label]));

export const actionLabel = (type) => LABELS[type] || type || "Autre";

/** Les actions qui passent par un email — et peuvent donc partir tout de suite. */
export const isEmailAction = (type) => type === "EMAIL" || type === "VIDEO";
